module.exports = __webpack_public_path__ + "img/Saudi.a7979dcb.png";